import React, { useState, useEffect } from 'react';
import styles from 'components/button-dialog/index.module.scss';
import classname from 'classnames/bind';
import DialogLayout from 'components/dialog-layout';
import LoadingDialog from 'components/loading-dialog';

const cx = classname.bind(styles);

/**
 * @param item.theme ('positive'|'negative' | 'cancel')
 * @param item.content (string)
 * @param item.onClick (func)
 * @param item.beLoading (boolean) 按鈕點擊後會loading則設置為true
 */

const ButtonDialog = ({ image, title, children, items = [], isShow = false }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isShow) {
      setLoading(isShow);
    }
  }, [isShow]);

  const DialogButton = ({ item }) => {
    const buttonClasses = cx({
      button: true,
      'positive-btn': item.theme === 'positive',
      'negative-btn': item.theme === 'negative',
      'close-btn': item.theme === 'cancel',
    });

    return (
      <div
        className={buttonClasses}
        onClick={() => {
          if (item.onClick) {
            if (item.beLoading) {
              setLoading(true);
            }
            item.onClick();
          }
        }}
      >
        {item.content}
      </div>
    );
  };

  const buttonDialogStyles = cx({
    'button-dialog': true,
    'is-loading': loading,
  });

  const buttonGroupClass = cx({
    ['button-group']: true,
    horizonal: items.length <= 2,
  });

  return (
    <DialogLayout isShow={isShow}>
      <LoadingDialog isShow={loading} />
      <div className={buttonDialogStyles}>
        {image && (
          <div className={styles.image}>
            <img src={image} />
          </div>
        )}
        <div className={styles['title']}>{title}</div>
        {children ? <div className={styles['content']}>{children}</div> : <></>}
        <div className={buttonGroupClass}>
          {items.map((item, index) => {
            return <DialogButton key={index} item={item} />;
          })}
        </div>
      </div>
    </DialogLayout>
  );
};

export default ButtonDialog;
